import React from 'react'
import * as pathname from './pathname'
import { MODULES, GROUPS, METHOD } from '../../utils/constants/roles'
import Settings from '../../views/settings/Settings'
import Users from '../../views/users/Users'
import Roles from '../../views/roles/Roles'
import Role from '../../views/roles/role/Role'
import Companies from '../../views/companies/Companies'
import Mutuals from '../../views/mutuals/Mutuals'
import Billables from '../../views/settings/general/Billables'
import CenterConventions from '../../views/settings/centers/CenterConventions'
import Inputs from '../../views/settings/general/Inputs'
import Populations from '../../views/settings/general/Populations'
import States from '../../views/settings/general/States'
import CenterAspiratorTypes from '../../views/settings/centers/CenterAspiratorTypes'
import CenterComercialData from '../../views/settings/centers/CenterComercialData'
import CenterServicesTypes from '../../views/settings/centers/CenterServiceTypes'
import CenterGasTypes from '../../views/settings/centers/CenterGasTypes'
import CenterHeaterTypes from '../../views/settings/centers/CenterHeaterTypes'
import CenterOtherTecnicsTypes from '../../views/settings/centers/CenterOtherTecnicsTypes'
import CenterPlattenTypes from '../../views/settings/centers/CenterPlattenTypes'
import CenterSoapTypes from '../../views/settings/centers/CenterSoapTypes'
import CenterTrackTypes from '../../views/settings/centers/CenterTrackTypes'
import CenterWashingTypes from '../../views/settings/centers/CenterWashingTypes'
import CenterMaintenanceTypes from '../../views/settings/centers/CenterMaintenanceTypes'

const usersRoutes = [
  {
    path: pathname.usersPathname.USERS,
    name: 'users',
    element: <Users />,
    role: {
      module: MODULES.USERS,
      group: GROUPS.BASIC_INFO,
      method: METHOD.GET,
    },
  },
]

const rolesRoutes = [
  {
    path: pathname.rolesPathname.ROLES,
    name: 'roles',
    element: <Roles />,
    role: { module: MODULES.SETTINGS, group: GROUPS.ROLES, method: METHOD.GET },
  },
  {
    path: pathname.rolesPathname.ROLE(':id'),
    name: 'role',
    element: <Role />,
    role: { module: MODULES.SETTINGS, group: GROUPS.ROLES, method: METHOD.GET },
  },
]

const conmpaniesRoutes = [
  {
    path: pathname.companiesPathname.COMPANIES,
    name: 'companies',
    element: <Companies />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.COMPANIES,
      method: METHOD.GET,
    },
  },
]

const mutualsRoutes = [
  {
    path: pathname.mutualsPathname.MUTUALS,
    name: 'mutuals',
    element: <Mutuals />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.MUTUAL,
      method: METHOD.GET,
    },
  },
]

const generalRoutes = [
  {
    path: pathname.generalPathname.BILLABLES,
    name: 'billables',
    element: <Billables />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.BILLABLES,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.generalPathname.CONVENTIONS,
    name: 'conventions',
    element: <CenterConventions />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CONVENTIONS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.generalPathname.INPUTS,
    name: 'inputs',
    element: <Inputs />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.INPUTS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.generalPathname.POPULATIONS,
    name: 'populations',
    element: <Populations />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.POPULATIONS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.generalPathname.STATES,
    name: 'states',
    element: <States />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.STATES,
      method: METHOD.GET,
    },
  },
]

const centerRoutes = [
  {
    path: pathname.centerPathname.ASPIRATOR,
    name: 'aspirator',
    element: <CenterAspiratorTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.COMERCIAL_DATA,
    name: 'comercialData',
    element: <CenterComercialData />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.SERVICES_TYPES,
    name: 'centerServicesTypes',
    element: <CenterServicesTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.GAS_TYPES,
    name: 'centerGasTypes',
    element: <CenterGasTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.HEATER_TYPES,
    name: 'heaterTypes',
    element: <CenterHeaterTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.OTHER_TECNICS_TYPES,
    name: 'otherTecnicsTypes',
    element: <CenterOtherTecnicsTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.PLATTEN_TYPES,
    name: 'plattenTypes',
    element: <CenterPlattenTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.SOAP_TYPES,
    name: 'soapTypes',
    element: <CenterSoapTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.TRACK_TYPES,
    name: 'trackTypes',
    element: <CenterTrackTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.WASHING_TYPES,
    name: 'washingTypes',
    element: <CenterWashingTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
  {
    path: pathname.centerPathname.MAINTENANCE_TYPES,
    name: 'maintenanceTypes',
    element: <CenterMaintenanceTypes />,
    role: {
      module: MODULES.SETTINGS,
      group: GROUPS.CENTERS,
      method: METHOD.GET,
    },
  },
]

const settingsRoutes = [
  {
    path: pathname.settingsPathname.SETTINGS,
    name: 'settings',
    element: <Settings />,
  },
  ...rolesRoutes,
  ...usersRoutes,
  ...conmpaniesRoutes,
  ...mutualsRoutes,
  ...generalRoutes,
  ...centerRoutes,
]

export { settingsRoutes }
